jQuery(function($) {
    var lastScrollTop = 0;
    var navbarTop = $('.navbar-top');
    var navbarBottom = $('.navbar-bottom');
    var navbar = $('.navbar');
    var navbarHeightDefault = 127;  
    var navbarHeightAtTop = 84;    
    var navbarTopHeight = navbarTop.outerHeight();
    let removeStickyTimeout;
    let isHoveringNavbar = false;

    function toggleNavbarTop(isAtTop) {
        if (isAtTop) {
            navbarBottom.css('top', 0);
            navbarTop.addClass('hidden');
            navbar.css('height', navbarHeightAtTop); 
            navbar.removeClass('sticky-top');
            navbarTop.css('top', '-32px'); 
        } else {
            navbarBottom.css('top', 43);
            navbarTop.removeClass('hidden');
            navbar.css('height', navbarHeightDefault); 
            navbar.addClass('sticky-top');
            navbarTop.css('top', '0'); 
        }
    }

    
    navbar.on('mouseenter', function() {
        isHoveringNavbar = true;
        navbar.addClass('hovered');
        clearTimeout(removeStickyTimeout);
        navbarTop.removeClass('hidden');
        navbarBottom.css('top', 43);
        navbar.addClass('sticky-top');
        navbarTop.css('top', '0');
        navbar.css('transform', 'translateY(0)');
    });

    navbar.on('mouseleave', function() {
        isHoveringNavbar = false;
        navbar.removeClass('hovered');

        if ($(window).scrollTop() === 0) {
            navbarTop.addClass('hidden');
            navbarBottom.css('top', 0);
            navbarTop.css('top', '-32px');
            removeStickyTimeout = setTimeout(function () {
                navbar.removeClass('sticky-top');
            }, 300);
        } else {
            navbar.addClass('sticky');
            navbarTop.addClass('hidden');
            navbar.css('transform', 'translateY(-' + navbarTopHeight + 'px)');
        }
    });

    $(window).on('scroll', function() {
        var currentScrollTop = $(this).scrollTop();
        if (!navbar.hasClass('hovered') && currentScrollTop > 0 && navbar.css('transform') === 'matrix(1, 0, 0, 1, 0, 0)') {
            navbar.addClass('sticky');
            navbarTop.addClass('hidden');
            navbar.css('transform', 'translateY(-' + navbarTopHeight + 'px)');
        }
        var isAtTop = currentScrollTop === 0;

        if (currentScrollTop > lastScrollTop && currentScrollTop > navbarTopHeight) {
            navbar.addClass('sticky'); 
            navbarTop.addClass('hidden'); 
            navbar.css('transform', 'translateY(-' + navbarTopHeight + 'px)'); 
        } else if (currentScrollTop < lastScrollTop) {
            navbar.removeClass('sticky'); 
            navbarTop.removeClass('hidden'); 
            navbar.css('transform', 'translateY(0)'); 
        }

        toggleNavbarTop(isAtTop);

        lastScrollTop = currentScrollTop;
    });

    
    var hash = window.location.hash;
    var headerHeight = $('.sticky-top').outerHeight(); 
    if (hash) {
        var target = $(hash);
        if (target.length) {
            $('html, body').animate({
                scrollTop: target.offset().top - headerHeight - 180
            }, 500);
        }
    }
});

$(document).ready(function() {
    let navbar = $('.navbar');

    function checkScroll() {
        if ($(window).scrollTop() > 100) {
            navbar.addClass('shadow');
        } else {
            navbar.removeClass('shadow');
        }
    }

    $(window).on('scroll', function() {
        checkScroll();
    });

    checkScroll();
});
